/* Shared
 * 共有クラス.
 */
export class Shared {

	protected static _instance: Shared;
	public static get(params?: {}): Shared {
		if ((Shared._instance === undefined) && (params != undefined)) {
			new Shared(params);
		}
		return Shared._instance;
	}

	// コンストラクタ
	constructor(params: {}) {
		Shared._instance = this;
	}

	/* getURL
	 * 指定のURLを返す.
	 */
	public getUrl(id: string): string { return './'; }
	/* getLang
	 * 言語を返す.
	 */
	public getLang(): string {
		if ((document != undefined) && (document.documentElement != undefined) && (document.documentElement.lang != undefined) && (document.documentElement.lang != ''))
			return document.documentElement.lang;
		return 'ja';
	}
}

export class mesUtils {
	public static get(message: string, lang?: string) {
		if (lang == undefined) lang = Shared.get().getLang();
		let reg: RegExp = new RegExp("<" + lang + ">(.*)<\/" + lang + ">")
		let match = message.match(reg);
		return ((match != undefined) && (match.length > 1)) ? match[1] : message;
	}
	public static getMessage(messages: any, lang?: string) {
		if ((messages == undefined) || (messages.length < 1)) return undefined;
		if (lang == undefined) lang = Shared.get().getLang();
		let $child = $(messages[0]).children(lang);
		if ($child.length > 0) return $child.text();
		return messages[0];
	}
}
